<template>
  <div class="cen">
    <div class="d-flex flex-column min-vh-100">
      <a-layout id="components-layout-demo-custom-trigger">
        <a-layout-sider
          theme="light"
          class="contents"
          v-model="collapsed"
          :trigger="null"
          collapsible
        >
          <div class="logo">
            <router-link class="nav-link" to="/">
              <a-icon type="home" :style="{ fontSize: '28px' }" />
            </router-link>
          </div>          
          <a-menu
            theme="light"
            mode="inline"
            :default-open-keys="openKeys"
            :default-selected-keys="['1']"
          >
            <a-sub-menu style="text-align: left;" v-for="item in Getmenus" :key="item.id">
              <span slot="title" >
                <a-icon :type="item.icon" />
                <span v-text="item.title"></span>
              </span>
              <a-menu-item v-for="obj in item.acts_detailpermission" :key="obj.id">                 
                 <router-link :to="{name:obj.vals}">{{obj.title}}</router-link>
              </a-menu-item>
            </a-sub-menu>
          </a-menu>
        </a-layout-sider>
        <a-layout>
        <a-layout-header class="modern-header">
          <div class="header-container">
            <!-- 左側控制區域 -->
            <div class="header-left">
              <button 
                class="sidebar-toggle"
                @click="() => (collapsed = !collapsed)"
                :class="{ 'collapsed': collapsed }"
              >
                <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
              </button>
              
              <div class="brand-section">
                <router-link :to="{name:'Center'}" class="brand-link">
                  <a-icon type="dashboard" class="brand-icon" />
                  <span class="brand-text">管理中心</span>
                </router-link>
              </div>
              
              <div class="org-selector-wrapper">
                <div class="selector-label">
                  <a-icon type="team" />
                  <span>主辦身份</span>
                </div>
                <a-select 
                  v-model="itemval" 
                  size="large"
                  class="org-selector"
                  @change="handleChange"
                  :getPopupContainer="trigger => trigger.parentNode"
                  :dropdownMatchSelectWidth="false"
                  dropdownClassName="org-selector-dropdown"
                >
                  <a-select-option v-for="item in orgdata" :value="item.id" :key="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
                
                <!-- 狀態標籤 -->
                <div class="status-tags">
                  <a-tag 
                    v-if="defaultval.state=='N'" 
                    color="orange"
                    class="status-tag"
                  >
                    <a-icon type="clock-circle" />
                    未審核
                  </a-tag>
                  
                  <a-tag 
                    v-if="mylevel && mylevel.mydata.name && mylevel.mydata.name !== 'admin'" 
                    color="red"
                    class="status-tag"
                    style="padding:0.5rem;font-weight: bold;"
                  >
                    <a-icon type="apartment" />
                    上層：{{ mylevel.mydata.name }}
                  </a-tag>
                </div>
              </div>
            </div>

            <!-- 右側通知區域 -->
            <div class="header-right">
              <!-- 訊息通知 -->
              <a-dropdown 
                :trigger="['click']"
                placement="bottomRight"
                overlayClassName="notification-dropdown"
              >
                <div class="notification-item">
                  <a-badge 
                    :count="gemess ? 'New' : 0" 
                    :offset="[-2, 2]"
                    :showZero="false"
                  >
                    <div class="notification-button message-btn">
                      <a-icon type="message" />
                    </div>
                  </a-badge>
                </div>
                
                <div slot="overlay" class="notification-dropdown-content">
                  <div class="notification-header">
                    <a-icon type="message" />
                    <span>最新訊息</span>
                  </div>
                  
                  <div class="notification-content">
                    <div 
                      v-for="item in items" 
                      :key="item.id"
                      class="notification-list-item"
                      @click="handleMessageItemClick(item.id)"
                    >
                      <div class="item-avatar">
                        <a-avatar size="small" icon="mail" />
                      </div>
                      <div class="item-content">
                        <span class="item-title">
                          {{ txtmess(item.title, 15) }}
                        </span>
                      </div>
                    </div>
                    
                    <div v-if="items.length === 0" class="empty-state">
                      <a-icon type="inbox" />
                      <span>暫無新訊息</span>
                    </div>
                  </div>
                  
                  <div class="notification-divider"></div>
                  <div class="view-all-item" @click="handleViewAllMessagesClick">
                    <a-icon type="arrow-right" />
                    查看所有訊息
                  </div>
                </div>
              </a-dropdown>

              <!-- 公告通知 -->
              <a-dropdown 
                :trigger="['click']"
                placement="bottomRight"
                overlayClassName="notification-dropdown"
              >
                <div class="notification-item">
                  <a-badge 
                    :count="alertmess ? 'New' : 0" 
                    :offset="[-2, 2]"
                    :showZero="false"
                  >
                    <div class="notification-button alert-btn">
                      <a-icon type="bell" />
                    </div>
                  </a-badge>
                </div>
                
                <div slot="overlay" class="notification-dropdown-content">
                  <div class="notification-header">
                    <a-icon type="bell" />
                    <span>最新公告</span>
                  </div>
                  
                  <div class="notification-content">
                    <div 
                      v-for="item in altdata" 
                      :key="item.id"
                      class="notification-list-item"
                      @click="handleAlertItemClick(item.id)"
                    >
                      <div class="item-avatar">
                        <a-avatar size="small" icon="notification" />
                      </div>
                      <div class="item-content">
                        <span class="item-title">
                          {{ txtmess(item.title, 15) }}
                        </span>
                      </div>
                    </div>
                    
                    <div v-if="altdata.length === 0" class="empty-state">
                      <a-icon type="inbox" />
                      <span>暫無新公告</span>
                    </div>
                  </div>
                  
                  <div class="notification-divider"></div>
                  <div class="view-all-item" @click="handleViewAllAlertsClick">
                    <a-icon type="arrow-right" />
                    查看所有公告
                  </div>
                </div>
              </a-dropdown>
            </div>
          </div>
        </a-layout-header>
          <a-layout-content class="ddic" :style="{ margin: '24px 16px', padding: '10px', background: '#fff', minHeight: '280px' }" >
          <router-view></router-view>
          </a-layout-content>
          <a-layout-footer class="contents">
            <span style="color:#b2b5b6;">≡.Design：宸緯資訊有限公司</span>
          </a-layout-footer>
        </a-layout>
      </a-layout>
        <b-alert
          v-model="showTop"
          class="position-fixed fixed-bottom m-0 rounded-0"
          style="z-index: 2000;"
          variant="warning"
          dismissible
        >
          請確認是否有公告/訊息, 尚未處理謝謝
        </b-alert>      
    </div>
  </div>
</template>
<script>
import router from "../router";
import { mapState, mapActions,mapMutations } from "vuex";


export default {
  name: "Center",
  components: {},
  data() {
    return {
      collapsed: false,
      //openKeys: ["a1", "a2", "a3", "a4", "a5"],
      openKeys: [],
      disableds: false,
      visibley: false,
      messsage: null,
      title: { title: "主辦活動", logo: "menu-unfold" },
      current: 0,
      stepdata: [],
      orgdata:[],
      itemval :"",
      alertmess : null,
      gemess :null,
      altdata : [],
      items : [],  
      messagedb:[],  
      showTop: false       
    };
  },
  methods: {
    ...mapActions("account", ["logout", "checktoken"]),
    ...mapActions("mact", ["insertmact"]),
    ...mapMutations('ws',['sendMessage','setWsMess']),
    ...mapActions('makeorg',['readorg','setorgval','getorglevel']),

    handleChange(value) {
          //console.log(`selected ${value}`);
          let temp =  this.orgdata.filter(rs => rs.id ==value)
          //console.log(this.orgdata)
          let athority = temp[0].acts_authority.find(rs => rs.Uid == this.user.data.user.id) 
          this.setorgval( {name: temp[0].name,id:temp[0].id ,state:temp[0].state,type:temp[0].type , permissions:athority  } )
        }, 
    async upload(){
        this.orgdata = this.datas;
        this.itemval = this.defaultval.name
    },   
    txtmess(val,i) {
      return val.substr(0,i)+"......"
    },
    
    loadmess(){
          let obj ={
            type:"load",
            pid:this.user.data.user.id,
            rmg: "",
            tomenss: [{id:this.user.data.user.id}]
            }
          this.sendMessage(JSON.stringify(obj))
    },
    revises(obj){
      let tmp = [];
      for(let i in obj){
        if(obj[i].vals!=='Chartreport'){
          if(obj[i].vals==='linecomment'){
            let Dtemp = obj[i].acts_detailpermission.filter(rs => rs.vals =='Line_control')
            obj[i].acts_detailpermission = Dtemp
            tmp.push(obj[i])
          }else{
            tmp.push(obj[i])
          }
        }
      }            
      return tmp.sort((a, b) => a.seq - b.seq);
    },

    // 處理訊息項目點擊
    handleMessageItemClick(itemId) {
      // 檢查是否與當前路由相同
      if (this.$route.name !== 'Info_detail' || this.$route.params.id !== String(itemId)) {
        this.$router.push({ 
          name: 'Info_detail', 
          params: { id: itemId } 
        });
      }
    },
    
    // 處理公告項目點擊
    handleAlertItemClick(itemId) {
      // 檢查是否與當前路由相同
      if (this.$route.name !== 'Info_detail' || this.$route.params.id !== String(itemId)) {
        this.$router.push({ 
          name: 'Info_detail', 
          params: { id: itemId } 
        });
      }
    },
    
    // 處理查看所有訊息點擊
    handleViewAllMessagesClick() {
      // 檢查是否與當前路由相同
      if (this.$route.name !== 'Info_center') {
        this.$router.push({ name: 'Info_center' });
      }
    },
    
    // 處理查看所有公告點擊
    handleViewAllAlertsClick() {
      // 檢查是否與當前路由相同
      if (this.$route.name !== 'Info_center') {
        this.$router.push({ name: 'Info_center' });
      }
    }    
  },
  computed: {
    ...mapState("account", ["status", "user"]), 
    ...mapState("makeorg", ["datas","defaultval","mylevel"]),
    ...mapState("ws", ["wsNotify","wsState","socket","wsMess","wsChang"]),
    Getmenus(){
      return this.revises(this.defaultval.permissions.acts_permissions)
    },

  },
  watch: {
      defaultval(val){
        this.itemval = val.name
        this.getorglevel( {id:this.defaultval.id} )
      },
      datas(){
        this.upload();       
      },
      wsNotify(val){
        this.altdata = [] 
        this.items =[]
        console.log(val)
        this.gemess =null
        this.alertmess=null        
              if(val){
                let {data} = val;
                //let tdata =null
                let itmes = {}  

                /*this.$notification['info']({
                  message: '訊息公告提示',
                  description:'請確認是否有公告/訊息, 尚未處理謝謝',
                  //style: getNotificationStyle('warning'),
                  duration: 1.5,
                });*/          


                  for(var obj in data) {
                      itmes =data[obj]
                        if(data[obj].typ==='mess'){
                            //console.log("------------",this.items.find(item => item.id == data[obj].id),"id:",data[obj].id)
                            //tdata = Number(this.gemess==null?0:this.gemess) +1
                            this.gemess =  "New"   
                            this.items.push(itmes);
                        }else if(data[obj].typ==='alert'){ 
                            //tdata = Number(this.alertmess==null?0:this.alertmess) +1
                            this.alertmess =  "New"           
                            this.altdata.push(itmes);
                        }  
                  }
                  this.messagedb =[]
                  for(var s in this.items){
                      this.messagedb.push(this.items[s])  
                  }
                  for(var k in this.altdata){
                      this.messagedb.push(this.altdata[k])  
                  }            
                  
                

                  var byDate = this.items.slice(0);
                  this.items=byDate.sort((a,b)=> {
                      return Date.parse(b.created_at) - Date.parse(a.created_at);
                  });

                  var byDate2 = this.altdata.slice(0);
                  this.altdata= byDate2.sort((a,b)=> {
                      return Date.parse(b.created_at) - Date.parse(a.created_at);
                  });
                  let tmpdata =[]
                  let i=0
                  for(var ob1 in this.items){
                      if(i<5){
                        tmpdata.push(this.items[ob1])  
                      }else if (i>5){
                        break
                      }            
                      i++
                  }
                  this.items = tmpdata  
                  let tmpdata2=[] 
                  let j=0       
                  for(var ob2 in this.altdata){
                      if(j<5){
                        tmpdata2.push(this.altdata[ob2])  
                      }else if (j>5){
                        break
                      }           
                      j++
                  }
                  this.altdata = tmpdata2
                  if(this.messagedb.length>0){
                    this.showTop = true;
                    setTimeout(() => {   
                        this.showTop = false;
                        clearInterval();
                    }, 4000);
                  }

                  
              }
      },

    wsState(val){
      if(val==true){
        this.loadmess()
      }
    },

    wsChang(val){
      let index=0
      //console.log(val)
      for (let itme in this.items) {
          if(this.items[itme].id==val){ 
            this.items.splice(index, 1);  
            if(this.items.length==0){
              this.gemess=null
            }                                           
            break;
          }
          index++
      }                
      index=0
      for (let itme in this.altdata) {
          if(this.altdata[itme].id==val){  
            this.altdata.splice(index, 1);  
            if(this.altdata.length==0){
              this.alertmess=null
            }
            break;
          }
          index++
      } 
      index=0
      for (let itme in this.messagedb) {
          if(this.messagedb[itme].id==val){ 
            this.messagedb.splice(index, 1);                          
            break;
          }
          index++
      }                  

    },

    messagedb(val){
      this.setWsMess({data: val}); 
    }

    },   
  mounted() {
    if (this.user == null) {
      router.replace("/");
    } else {
      this.checktoken();
    }
    if(this.wsState==true){
      this.loadmess()
    } 
    if(this.defaultval.id!==''){
      this.getorglevel( {id:this.defaultval.id} ) 
    } 
 
  },
  created() {
      this.upload();
      //console.log(this.defaultval)
  }
};
</script>
<style scoped>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #7fbcf5;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  margin: 16px;
}

.ddic {
  border-radius: 16px;
  box-shadow: 1px 1px 15px -5px rgb(175, 174, 174);
  transition: all 0.3s ease;
}

.contents {
  background: #fff;
  box-shadow: 1px 1px 15px -5px rgb(175, 174, 174);
  padding: 0px;
}

.my-span {
  padding: 5px 10px; /* 調整內邊距 */
  border: 1px solid #bfdaf5; /* 設置邊線 */
  border-radius: 5px; /* 添加倒角 */
  background-color: #d6e9fc;
}

/* 現代化 Header */
.modern-header {
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 0;
  height: 64px;
  position: relative;
  z-index: 10;
}

/* Header 容器 */
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 24px;
  max-width: none;
}

/* 左側區域 */
.header-left {
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
  min-width: 0;
}

/* 側邊欄切換按鈕 */
.sidebar-toggle {
  width: 40px;
  height: 40px;
  border: none;
  background: #f8f9fa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #666;
  font-size: 16px;
}

.sidebar-toggle:hover {
  background: #e9ecef;
  color: #1890ff;
}

.sidebar-toggle.collapsed {
  background: #e6f7ff;
  color: #1890ff;
}

/* 品牌區域 */
.brand-section {
  display: flex;
  align-items: center;
}

.brand-link {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #2c3e50;
  font-weight: 600;
  font-size: 18px;
  transition: color 0.3s ease;
}

.brand-link:hover {
  color: #1890ff;
}

.brand-icon {
  font-size: 20px;
  color: #1890ff;
}

.brand-text {
  font-weight: 600;
}

/* 組織選擇器包裝 */
.org-selector-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.selector-label {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
  white-space: nowrap;
}

.org-selector {
  min-width: 250px;
  max-width: 350px;
}

/* 狀態標籤 */
.status-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.status-tag {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  border-radius: 12px;
  font-size: 14px;
}

/* 右側區域 */
.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* 通知項目 */
.notification-item {
  cursor: pointer;
}

.notification-button {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-size: 18px;
}

.message-btn {
  background: #f6ffed;
  color: #52c41a;
}

.message-btn:hover {
  background: #d9f7be;
  transform: translateY(-1px);
}

.alert-btn {
  background: #fff7e6;
  color: #fa8c16;
}

.alert-btn:hover {
  background: #ffd591;
  transform: translateY(-1px);
}

/* 通知下拉選單 */
.notification-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
  font-weight: 600;
  color: #2c3e50;
}

.notification-content {
  max-height: 300px;
  overflow-y: auto;
  padding: 8px 0;
}

.notification-list-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  transition: background 0.2s ease;
}

.notification-list-item:hover {
  background: #f8f9fa;
}

.item-avatar {
  flex-shrink: 0;
  margin-top: 2px;
}

.item-content {
  flex: 1;
  min-width: 0;
}

.item-title {
  color: #2c3e50;
  text-decoration: none;
  font-size: 14px;
  line-height: 1.4;
  display: block;
}

.item-title:hover {
  color: #1890ff;
}

/* 空狀態 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  color: #999;
  font-size: 14px;
  gap: 8px;
}

/* 查看全部項目 */
.view-all-item {
  text-align: center;
  background: #fafafa;
}

.view-all-item a {
  color: #1890ff;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.view-all-item a:hover {
  color: #40a9ff;
}

/* 響應式設計 */
@media (max-width: 1200px) {
  .org-selector {
    min-width: 150px;
    max-width: 200px;
  }
  
  .status-tags {
    display: none;
  }
}

@media (max-width: 992px) {
  .header-container {
    padding: 0 16px;
  }
  
  .header-left {
    gap: 16px;
  }
  
  .selector-label {
    display: none;
  }
  
  .org-selector {
    min-width: 120px;
    max-width: 150px;
  }
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 12px;
  }
  
  .header-left {
    gap: 12px;
  }
  
  .brand-text {
    display: none;
  }
  
  .org-selector-wrapper {
    gap: 8px;
  }
  
  .org-selector {
    min-width: 100px;
    max-width: 120px;
  }
  
  .header-right {
    gap: 8px;
  }
  
  .notification-button {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .header-container {
    padding: 0 8px;
  }
  
  .org-selector {
    min-width: 80px;
    max-width: 100px;
  }
}

/* 全域下拉選單樣式 */
:global(.notification-dropdown .ant-dropdown-menu) {
  padding: 0;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: 1px solid #f0f0f0;
  min-width: 320px;
  max-width: 400px;
}

:global(.notification-dropdown .ant-dropdown-menu-item) {
  padding: 0;
  margin: 0;
}

:global(.notification-dropdown .ant-dropdown-menu-item:hover) {
  background: transparent;
}

/* 通知下拉內容 */
.notification-dropdown-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: 1px solid #f0f0f0;
  min-width: 320px;
  max-width: 400px;
  overflow: hidden;
}

/* 通知項目可點擊樣式 */
.notification-list-item {
  cursor: pointer;
}

.notification-list-item:hover {
  background: #f8f9fa;
}

/* 分隔線 */
.notification-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 0;
}

/* 查看全部按鈕 */
.view-all-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 16px;
  background: #fafafa;
  color: #1890ff;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-all-item:hover {
  background: #f0f0f0;
  color: #40a9ff;
}

/* 項目標題樣式 */
.item-title {
  cursor: pointer;
  transition: color 0.2s ease;
}

.notification-list-item:hover .item-title {
  color: #1890ff;
}

/* 更新全域樣式覆蓋 */
:global(.notification-dropdown .ant-dropdown-menu) {
  padding: 0 !important;
}
/* 下拉選單樣式 */
:global(.org-selector-dropdown) {
  min-width: 280px !important;
  max-width: 400px !important;
}

:global(.org-selector-dropdown .ant-select-dropdown-menu) {
  padding: 8px 0 !important;
}

:global(.org-selector-dropdown .ant-select-dropdown-menu-item) {
  text-align: left !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  min-height: 36px !important;
  display: flex !important;
  align-items: center !important;
}

:global(.org-selector-dropdown .ant-select-dropdown-menu-item:hover) {
  background-color: #f5f5f5 !important;
}

:global(.org-selector-dropdown .ant-select-dropdown-menu-item-selected) {
  background-color: #e6f7ff !important;
  color: #1890ff !important;
  font-weight: 600 !important;
}

/* 響應式調整 */
@media (max-width: 1200px) {
  .org-selector {
    min-width: 200px;
    max-width: 280px;
  }
  
  :global(.org-selector-dropdown) {
    min-width: 220px !important;
    max-width: 300px !important;
  }
}
</style>